
<script setup>
import { Hints, Heading, MultiSelect, SectionHead } from '@components'

// Settings
import DarkModeStore from '@o/store'
const { options } = DarkModeStore()

// Contents
import useContents from '@stores/contents'
const $contents = useContents()

import { getSlugColor } from '@o/helper'

</script>

<template>
    <Row transparent gap="6"> <SectionHead class="text-lg"> Exclude Pages/ Posts <template #description>Exclude dark mode on
                specific WordPress post type and taxonomy</template>
        </SectionHead>

        <Row transparent>
            <Row inline transparent class="items-center" gap="2">
                <div class="text-sm font-normal text-gray-700">Exclude Post Type:</div>
                <span class="text-sm leading-5 font-normal px-3 py-1 rounded-full border-transparent"
                    v-for="(label, postType) in $contents.postTypes" :key="postType" :class="getSlugColor(postType)">{{ label
                    }}</span>
            </Row>
            <Row class="flex-col sm:flex-row" space>
                <Heading class="whitespace-nowrap">
                    <Row inline center>
                        <Row locked :ProBadge="false"  class="whitespace-nowrap">Exclude Pages/Posts</Row> <ProBadge />
                    </Row>
                </Heading>
                <Row class="w-full" locked>
                    <Row>
                        <MultiSelect :items="$contents.posts" group="type" :groups="$contents.postTypes"
                            placeholder="Enter your selected pages, posts and custom post types"
                            v-model="options.excludes_posts" :disabled="options.excludes_posts_all" />
                        <Hints>Add pages, posts and custom post types that you want to exclude from the dark mode.</Hints>
                    </Row>
                    <Row inline class="pt-[10px] text-sm"><span class="font-semibold">Exclude All</span>
                        <Toggle v-model="options.excludes_posts_all">Except:</Toggle>
                    </Row>
                    <Row>
                        <MultiSelect :items="$contents.posts" group="type" :groups="$contents.postTypes"
                            placeholder="Enter your selected pages, posts and custom post types"
                            v-model="options.excludes_posts_except" :disabled="!options.excludes_posts_all" />
                        <Hints>Dark Mode will only work on the selected posts and pages.</Hints>
                    </Row>
                </Row>
            </Row>
        </Row>
        <Row transparent>
            <Row inline transparent class="items-center justify-start" gap="2">
                <div class="text-sm font-normal text-gray-700">Exclude Taxonomy Type:</div>
                <span class="text-sm leading-5 font-normal px-3 py-1 rounded-full border-transparent"
                    v-for="(label, postType) in $contents.taxonomies" :key="postType" :class="getSlugColor(postType)">{{ label
                    }}</span>
            </Row>
            <Row class="flex-col sm:flex-row" space>
                <Heading class="whitespace-nowrap">
                    <Row inline center>
                        <Row locked :ProBadge="false"  class="whitespace-nowrap">Exclude Taxonomies</Row> <ProBadge />
                    </Row>
                </Heading>
                <Row class="w-full" locked>
                    <MultiSelect placeholder="Enter your selected categories and tags" :items="$contents.terms" group="tax"
                        :groups="$contents.taxonomies" v-model="options.excludes_taxonomies"
                        :disabled="options.excludes_taxonomies_all" />
                    <Hints>Include the categories and tags that you want to exclude from the dark mode.</Hints>
                    <Row inline class="pt-[10px] text-sm"><strong>Exclude All</strong>
                        <Toggle v-model="options.excludes_taxonomies_all">Except:</Toggle>
                    </Row>
                    <MultiSelect placeholder="Enter your selected categories and tags" :items="$contents.terms" group="tax"
                        :groups="$contents.taxonomies" v-model="options.excludes_taxonomies_except"
                        :disabled="!options.excludes_taxonomies_all" />
                    <Hints>Dark Mode will only work on the selected posts and pages.</Hints>
                </Row>
            </Row>
        </Row>
    </Row>
</template>
